import Link from "next/link";
import ShButton from "../../../components/button/shButton";
import {useRouter} from "next/router";

const InternalButton = ( { children, to, test } ) => {

    const router = useRouter();

    return <ShButton variant={"primary"}
        onClick={
            () => {


                if (!to) return;

                const uri = "https://7hauben.com";
                let newTo = to + "";

                if (newTo.startsWith(uri)) {
                    newTo = to.substring(uri.length);
                }

                router.push(newTo);
            }
        }
    >
        { children }
        </ShButton>;

};

export default InternalButton;
